import 'swiper/css';
import { PropsWithChildren, useRef, useState } from 'react';
import { Carousel } from '@meritcircle/ui/components/carousel/carousel';
import { Tile } from '@meritcircle/ui/components/tile/tile';
import { AspectRatio, Box, useBreakpointValue } from '@chakra-ui/react';
import { GenreCarouselProps } from './genre-carousel.types';
import { parseGenresToCarouselSlides } from './genre-carousel.helpers';
import { URLS } from '@/config/urls';

export const GenreCarousel = ({ slides, ...rest }: PropsWithChildren<GenreCarouselProps>) => {
  const slidesPerView = useBreakpointValue({ base: 2, md: 3.2, lg: 4, xl: 5.5 });
  const slidesPerGroup = useBreakpointValue({ base: 2, md: 3, xl: 4 });

  const [isHovering, setIsHovering] = useState(false);
  const carouselRef = useRef<HTMLDivElement>();

  const parsedSlides = parseGenresToCarouselSlides(slides);

  return (
    <Box>
      <Carousel
        {...rest}
        slidesPerView={slidesPerView}
        slidesPerGroup={slidesPerGroup}
        ref={carouselRef}
        wrapperProps={{ pb: { base: '2xl', md: '4xl' } }}>
        {parsedSlides.map(slide => (
          <Box
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            position="relative"
            key={slide.title}>
            <AspectRatio ratio={10 / 16}>
              <Box
                transition="0.15s ease-out"
                opacity={isHovering ? '0.7' : '1'}
                _hover={{ opacity: 1 }}
                marginLeft="4px"
                h="100%"
                w="100%">
                <Tile
                  h="100%"
                  title={slide.title}
                  titleSize="sm"
                  image={slide.image}
                  href={`${URLS.GAMES_ALL}?categories=${slide.title}`}
                />
              </Box>
            </AspectRatio>
          </Box>
        ))}
      </Carousel>
    </Box>
  );
};
